import React from 'react';
import Drawer from '@material-ui/core/Drawer';

import styles from './SGSDrawer.module.scss';
import { Box } from '@material-ui/core';

type ContainerStyle = 'container' | 'container-W-914' | 'container-W-800' | 'container-W-700';

type Props = {
    open: boolean;
    toggleDrawer: Function;
    onClose?: Function;
    containerStyle?: ContainerStyle;
};

const SGSDrawer: React.FC<Props> = ({ open, toggleDrawer, onClose, children, containerStyle = 'container' }) => {
    const onDrawerClose = () => {
        if (onClose) onClose();
        toggleDrawer(false);
    };

    return (
        <div>
            <React.Fragment>
                <Drawer anchor={'right'} open={open} onClose={onDrawerClose} classes={{ paper: styles.paper }}>
                    <Box className={styles[containerStyle]}>
                        <Box className={styles.closeIcon} onClick={onDrawerClose}>
                            <i className="fas fa-times"></i>
                        </Box>
                        <Box>{children}</Box>
                    </Box>
                </Drawer>
            </React.Fragment>
        </div>
    );
};

export default SGSDrawer;
